import ApiService from "../../../../ceres/services/ApiService";
import DynamicItemListModule from "./DynamicItemListModule";
import { isDefined } from "../../../../ceres/helper/utils";

function meetsCallConditions(key, payload) {
	if (key === "simple_basket") {
		return isDefined(payload)
			&& isDefined(payload.params)
			&& isDefined(payload.params.variationIDs)
			&& payload.params.variationIDs.length > 0;
	}

	if (key === "prop_basket") {
		return isDefined(payload)
			&& isDefined(payload.params)
			&& isDefined(payload.params.propertyVariationIDList)
			&& payload.params.propertyVariationIDList.length > 0;
	}

	if (key === "tag_basket") {
		return isDefined(payload)
			&& isDefined(payload.params)
			&& isDefined(payload.params.attributeValueIDList)
			&& isDefined(payload.params.variationTagList)
			&& isDefined(payload.params.basketItemList)
			&& payload.params.attributeValueIDList.length > 0
			&& payload.params.variationTagList.length > 0
			&& payload.params.basketItemList.length > 0;
	}

	if (key === "attribute_crossselling") {
		return isDefined(payload)
			&& isDefined(payload.params)
			&& isDefined(payload.params.attributeValueIds)
			&& payload.params.attributeValueIds.length > 0;
	}

	if (key === "tag_item") {
		return isDefined(payload)
			&& isDefined(payload.params)
			&& isDefined(payload.params.attributeValueIDList)
			&& isDefined(payload.params.variationTagList)
			&& payload.params.attributeValueIDList.length > 0
			&& payload.params.variationTagList.length > 0;
	}

	return true;
}

const actions = {
	initDynamicItemList({ commit }, payload) {
		const key = payload.key || "random";
		const params = payload.params || {};
		const isUpdate = payload.isUpdate || false;
		const isPassive = payload.isPassive || false;
		const amazonListKeys = [
			"variation_relation_viewed_also_viewed",
			"variation_relation_viewed_also_bought",
			"variation_relation_bought_also_bought"
		];

		let containerKey = key;

		if (key === "simple" && Object.keys(params).includes("variationIDs") && params.variationIDs.length > 0) {
			containerKey += "-" + params.variationIDs[0];
		}

		if (isUpdate) {
			ceresStore.unregisterModule(["DynamicItemList", containerKey], DynamicItemListModule);
		}
		ceresStore.registerModule(["DynamicItemList", containerKey], DynamicItemListModule);

		commit(`${containerKey}/setItemListIsLoading`, true);

		if (meetsCallConditions(key, payload)) {
			if (!isPassive) {
				ApiService.get("/rest/dynamicItemList", { type: key, ...params })
					.done(response => {
						// jshint ignore:start
						if (amazonListKeys.includes(key)) {
							if (isDefined(response["viewedAlsoViewed"])) {
								const itemLists = response || [];
								const keyMap = {
									variation_relation_viewed_also_viewed: "viewedAlsoViewed", // eslint-disable-line id-length
									variation_relation_viewed_also_bought: "viewedAlsoBought", // eslint-disable-line id-length
									variation_relation_bought_also_bought: "boughtAlsoBought" // eslint-disable-line id-length
								};

								for (const amazonListKey in keyMap) {
									if (isDefined(itemLists[keyMap[amazonListKey]].items?.documents)) {
										const itemList = itemLists[keyMap[amazonListKey]].items?.documents || [];
										const containers = itemLists[keyMap[amazonListKey]].containers || {};

										commit(`${amazonListKey}/setItemList`, { itemList, containers });
									}
								}
							}
						} else if (isDefined(response.items?.documents)) {
							const itemList = response.items.documents || [];
							const containers = response.containers || {};

							commit(`${containerKey}/setItemList`, { itemList, containers });
						}
						// jshint ignore:end
						commit(`${containerKey}/setItemListIsLoading`, false);
					})
					.fail(error => {
						commit(`${containerKey}/setItemListIsLoading`, false);
						console.error(error); // eslint-disable-line no-console
					});
			}
		} else if(isUpdate &&
		[
			"simple_basket",
			"prop_basket",
			"tag_basket",
			"attribute_crossselling",
			"tag_item"
		].includes(key)) {
			// empty item list since nothing gets called
			commit(`${containerKey}/setItemList`, { itemList: [], containers: [] });
		}
	}
};

export default {
	actions
};